import React from "react";
import ClientCarousel from "./components/ClientCarousel";
import SectionHeading from "./components/SectionHeading";
import Header from "./components/Header";
import { Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Footer from "./components/Footer";
import AboutUsPage from "./pages/AboutUsPage";
import ServicesPage from "./pages/ServicesPage";
import ProjectsGalleryPage from "./pages/ProjectsGalleryPage";
import CredentialsPage from "./pages/CredentialsPage";
import ClientsPage from "./pages/ClientsPage";
import NotFoundPage from "./pages/NotFoundPage";
import ContactUsPage from "./pages/ContactUsPage";
import clientData from "./assets/data/client-data.json";
import CareersPage from "./pages/CareersPage";
import { AnimatePresence, MotionConfig, motion } from "framer-motion";
import usePageMeta from "./seo/usePageMeta";

function App() {
  const location = useLocation();
  usePageMeta(location.pathname);

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.3,
      },
    },
  };

  return (
    // Honour the OS "reduce motion" setting for every framer-motion animation
    <MotionConfig reducedMotion="user">
    <div className="App">
      <Header />
      <main className="pt-[68px] md:pt-[84px]">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <HomePage />
              </motion.div>
            }
          />
          <Route
            path="/about-us"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <AboutUsPage />
              </motion.div>
            }
          />
          <Route
            path="/services"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <ServicesPage />
              </motion.div>
            }
          />
          <Route
            path="/projects-gallery"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <ProjectsGalleryPage />
              </motion.div>
            }
          />
          <Route
            path="/credentials"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <CredentialsPage />
              </motion.div>
            }
          />
          <Route
            path="/clients"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <ClientsPage />
              </motion.div>
            }
          />
          <Route
            path="*"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <NotFoundPage />
              </motion.div>
            }
          />
          <Route
            path="/contact-us"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <ContactUsPage />
              </motion.div>
            }
          />
          <Route
            path="/careers"
            element={
              <motion.div
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <CareersPage />
              </motion.div>
            }
          />
      </Routes>
        </AnimatePresence>
      </main>

      {/* Hidden where the page already shows client logos */}
      {!["/clients", "/about-us"].includes(location.pathname) && (
        <section className="bg-gray-50 border-t border-gray-100 py-12 sm:py-16">
          <SectionHeading
            eyebrow="Trusted By"
            title="Our Clients"
            className="!mb-8"
          />
          <ClientCarousel logos={clientData} speed={40} pauseOnHover={true} />
        </section>
      )}

      <Footer />
    </div>
    </MotionConfig>
  );
}

export default App;
